<div class="grid text-sm w-full grid-cols-[repeat(8,1fr)]">
	<div
		class="ui-datepicker-calendar__calendarWeek bg-secondary-200 flex justify-center items-center"
	>
		{{ translatedCalendarWeek() }}
	</div>
	@for (weekDay of weekDays; track weekDay) {
		<div
			class="items-center bg-secondary-200 flex font-semibold justify-center overflow-hidden pt-2 pr-1 pb-2 pl-1 text-center select-none"
		>
			{{ translateWeekday(weekDay) }}
		</div>
	}
	@for (week of calendarWeeks(); track week.weekNumber) {
		<div
			class="grid-cols-[repeat(8,1fr)] items-center bg-secondary-200 flex justify-center overflow-hidden pt-2 pr-1 pb-2 pl-1 text-center select-none"
			(click)="onCalendarWeekClicked(week)"
		>
			{{ week.weekNumber }}
		</div>

		@for (day of week.days; track day.date) {
			<div
				class="items-center cursor-pointer flex justify-center overflow-hidden pt-2 pr-1 pb-2 pl-1 text-center select-none hover:bg-primary-300 focus-visible-border focus-visible:outline-none focus-visible:rounded"
				[ngClass]="{
					'bg-secondary-100 hover:bg-secondary-100':
						disabled() || day.disabled || day.notInActiveMonth,
					'cursor-not-allowed!': day.disabled || disabled() || day.notInActiveMonth,
					'bg-primary-300': isDateSelected(day),
					'bg-primary-200': isInRange(day),
					'line-through!': day.excluded,
					'bg-white!': day.excluded && !isDateSelected(day),
				}"
				#calendarDay
				[tabindex]="day.disabled || disabled() || day.notInActiveMonth ? -1 : 0"
				(click)="selectDay(day)"
				(keydown.enter)="selectDay(day)"
				[uiTooltip]="day | calendarDateTooltip"
			>
				{{ day.date | date: 'dd' }}
			</div>
		}
	}
</div>
